import * as React from 'react'

function BigExclamationIcon() {
  return (
    <svg width={12} height={48} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6 0C2.688 0 0 2.646 0 5.906v19.5c0 3.26 2.688 5.907 6 5.907s6-2.646 6-5.907v-19.5C12 2.646 9.312 0 6 0zm0 36.188c-3.312 0-6 2.645-6 5.906C0 45.354 2.688 48 6 48s6-2.646 6-5.906-2.688-5.907-6-5.907z'
        fill='#EEBB08'
      />
    </svg>
  )
}

export default BigExclamationIcon
